<template>
    <button type="button" class="c-scroll-down" title="Scroll down..." @click="scrollToSection" ref="scrollDown">
        <SvgsArrowLeft />
    </button>
</template>

<script setup>
    const { $gsap: gsap } = useNuxtApp();
    const scrollDown = ref(null);

    const scrollToSection = () => {
        gsap.to(window, {
            duration: 2,
            ease: "power4",
            scrollTo: {
                y: window.innerHeight
            }
        });
    };

    useStartAnimations(() => {
        gsap.to(scrollDown.value, { y: 0, ease: "back", duration: 1, delay: 1 });
    });
</script>
